'use client';

export default function IconRight() {
    return (
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M1.25 12.5L6.75 7L1.25 1.5" stroke="#FFBD3C" strokeWidth="1.375" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
